module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-day",
    class: _vm.classesDay,
    on: {
      "mouseenter": _vm.mouseEnterDay,
      "mouseleave": _vm.mouseLeaveDay,
      "mousemove": function($event) {
        $event.stopPropagation();
        return _vm.mouseMoveDay($event)
      },
      "mousedown": _vm.mouseDownDay,
      "mouseup": _vm.mouseUpDay,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    class: _vm.classesHeader
  }, [_c('a', {
    staticClass: "ds-dom",
    class: _vm.classesDayOfMonth,
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.viewDay($event)
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.dayOfMonth) + "\n    ")]), _vm._v(" "), (_vm.showMonth) ? _c('span', {
    staticClass: "ds-first-day"
  }, [_vm._v("\n      " + _vm._s(_vm.month) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.visibleEvents), function(event, i) {
    return [_c('ds-calendar-event', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "calendar-event": event,
        "calendar": _vm.calendar,
        "index": i
      }
    }, 'ds-calendar-event', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  }), _vm._v(" "), (_vm.hasPlaceholder) ? _c('div', [_c('ds-calendar-event-placeholder', _vm._g(_vm._b({
    attrs: {
      "day": _vm.day,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate,
      "calendar": _vm.calendar,
      "index": _vm.visibleEvents.length
    }
  }, 'ds-calendar-event-placeholder', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c181404","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Day.vue
// module id = 167
// module chunks = 0